export enum AddinTab {
  Signals = "signals",
  Analysis = "analysis",
  Simulator = "simulator",
}

export interface GlobalState {
  isComposeMode: boolean;
  isMaintenanceMode: boolean;
  activeTabId: AddinTab;
  isAboutModalOpened: boolean;
}
